import { createLoadingReducer } from './utils';
import { Company } from '@/types';

export default createLoadingReducer<Required<Company>>('COMPANY');

export const selectCompany = (state: any): Required<Company> | null => state.company.data;
